import ProductCardSkeleton from 'catalog/product/components/product-card/card-item.component/skeleton';
import Container from 'common/components/container.component';
import Pulsate from 'common/components/pulsate.component';
import { DeviceTypeList } from 'config/constants/global.constants';
import { useDeviceType } from 'config/hooks/useDeviceType.hook';
import { DeviceType } from 'config/types/common.type';
import React from 'react';
import styles from './style.module.scss';

const HomeSkeleton: React.FC = () => {
  const deviceType: DeviceType = useDeviceType();

  const renderProductRowSkeleton = (count: number): React.ReactNode[] => {
    const childs: React.ReactNode[] = [];
    for (let index = 0; index < count; index++) {
      childs.push(<ProductCardSkeleton key={index} />);
    }
    return childs;
  };

  const rowGridStyles: React.CSSProperties = {
    display: 'flex',
    gap: '16px',
    overflow: 'hidden',
    marginBottom: '40px',
  };

  const renderSectionSkeleton = (cardCount: number): React.ReactNode => (
    <div className={styles['home-section-skeleton']}>
      <Pulsate width='250px' height='32px' marginBottom='20px' />

      <div style={rowGridStyles}>{renderProductRowSkeleton(cardCount)}</div>
    </div>
  );

  const renderDesktopSkeleton = (): React.ReactNode => {
    return (
      <React.Fragment>
        {renderSectionSkeleton(7)}
        {renderSectionSkeleton(7)}
        {renderSectionSkeleton(7)}
      </React.Fragment>
    );
  };

  const renderMobileSkeleton = (): React.ReactNode => {
    return (
      <React.Fragment>
        {renderSectionSkeleton(2)}
        {renderSectionSkeleton(2)}
        {renderSectionSkeleton(2)}
      </React.Fragment>
    );
  };

  return (
    <Container>
      <div style={{ paddingTop: '40px' }}>{deviceType !== DeviceTypeList.DESKTOP ? renderMobileSkeleton() : renderDesktopSkeleton()}</div>
    </Container>
  );
};

export default HomeSkeleton;
